import { render } from "./kanban_cws.vue?vue&type=template&id=4615fd12"
import script from "./kanban_cws.vue?vue&type=script&lang=js"
export * from "./kanban_cws.vue?vue&type=script&lang=js"

import "./kanban_cws.vue?vue&type=style&index=0&id=4615fd12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__